// Store Imports
import { IConfiguration } from '@dashboard/models'
import { createReducer, on } from '@ngrx/store'
import {
	SET_CONFIGURATIONS,
	DELETE_ONE_CONFIGURATION,
	ADD_ONE_CONFIGURATION,
	UPDATE_ONE_CONFIGURATION,
} from '@store/actions'
// Shared Imports
import { IConfigurationsState } from '@store/models'

export const initialConfigurationState: IConfigurationsState = {
	original: [],
	filtered: [],
}

export const configurationsReducer = createReducer(
	initialConfigurationState,
	on(
		SET_CONFIGURATIONS,
		(previousState: IConfigurationsState, { configurations }): IConfigurationsState => {
			return { ...previousState, original: configurations, filtered: configurations }
		}
	),
	on(
		DELETE_ONE_CONFIGURATION,
		(previousState: IConfigurationsState, { configurationId }): IConfigurationsState => {
			const configurationsFiltered: IConfiguration[] = previousState.original.filter(
				(_configuration: IConfiguration) => _configuration.id !== configurationId
			)
			return {
				...previousState,
				original: configurationsFiltered,
				filtered: configurationsFiltered,
			}
		}
	),
	on(
		ADD_ONE_CONFIGURATION,
		(previousState: IConfigurationsState, { configuration }): IConfigurationsState => {
			const configurationsUpdated: IConfiguration[] = [configuration, ...previousState.original]
			return { ...previousState, original: configurationsUpdated, filtered: configurationsUpdated }
		}
	),
	on(
		UPDATE_ONE_CONFIGURATION,
		(previousState: IConfigurationsState, { configuration }): IConfigurationsState => {
			const configurationsFiltered: IConfiguration[] = previousState.original.filter(
				(_configuration: IConfiguration) => _configuration.id !== configuration.id
			)
			const configurationsUpdated: IConfiguration[] = [configuration, ...configurationsFiltered]
			const configurations: IConfiguration[] = [configuration, ...previousState.original]
			return { ...previousState, original: configurationsUpdated, filtered: configurationsUpdated }
		}
	)
)
